import React from 'react';
import { Title, Message, Container } from './geo-match-error.styles';
import { MAP_NAME } from './constants';
import text from './text.json';
var GeoMatchError = function (_a) {
    var geographicArea = _a.geographicArea;
    return (React.createElement(Container, null,
        React.createElement(Title, null,
            text.title,
            " ",
            MAP_NAME[geographicArea],
            " ",
            text.map),
        React.createElement(Message, null, text.message)));
};
export default GeoMatchError;
